'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { getAuthIdentity } from 'services/identity.service';
import { getUserOngoingEvents, getUserPastEvents } from 'services/user.service';

import { UserProfileLayout } from 'components/atomic/molecules';
import {
  HeaderOrganism,
  UserEventNavigatorOrganism
} from 'components/atomic/organism';
import { useUIContext } from 'components/context/uiContext/ManagedUiContext';
import { setSelectedCart } from 'services/cart.service';
import { setSelectedUserEvent } from 'services/myEvents.service';

const getOnGoingEvents = async (userId, setOnGoingEvents) => {
  const { status, entity } = await getUserOngoingEvents(userId);
  status && setOnGoingEvents(entity);
};

const getPastEvents = async (userId, setPastEvents) => {
  const { status, entity } = await getUserPastEvents(userId);
  status && setPastEvents(entity);
};

const loadAndSetEvents = async ({
  userId,
  setIsLoading,
  setOnGoingEvents,
  setPastEvents,
  removeSelectedUserEvent
}) => {
  setIsLoading(true);
  getOnGoingEvents(userId, setOnGoingEvents);
  getPastEvents(userId, setPastEvents);
  setIsLoading(false);

  if (removeSelectedUserEvent) {
    setSelectedCart({ data: null });
    setSelectedUserEvent({ data: null });
  }
};

export default function MyEvents() {
  const [isLoading, setIsLoading] = useState(false);
  const [onGoingEvents, setOnGoingEvents] = useState(false);
  const [pastEvents, setPastEvents] = useState(false);

  const searchParams = useSearchParams();
  const removeSelectedUserEvent = searchParams.get('removeSelectedUserEvent');

  const { authUser } = useUIContext();

  useEffect(() => {
    const { id: userId } = getAuthIdentity() || {};
    loadAndSetEvents({
      userId,
      setIsLoading,
      setOnGoingEvents,
      setPastEvents,
      removeSelectedUserEvent: Boolean(removeSelectedUserEvent)
    });
  }, [removeSelectedUserEvent]);

  return (
    <div>
      <HeaderOrganism heading='My Events' />
      <UserProfileLayout {...{ isLoading, name: authUser.name }}>
        {!isLoading && (
          <UserEventNavigatorOrganism
            {...{
              ongoingUserEventSummaryCardList: onGoingEvents,
              pastUserEventSummaryCardList: pastEvents
            }}
          />
        )}
      </UserProfileLayout>
    </div>
  );
}
